module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Moviles-3.e9eff0fb.png";